import React from 'react';

let iframe = function () {
    return {
        __html: "<iframe src='http://www.athens.kiev.ua/php/index.php' width='100%' height='800'></iframe>"
    }
};

const OldView = () => (
    <div>
        <div dangerouslySetInnerHTML={iframe()} />
    </div>
);

export default OldView;



/** WEBPACK FOOTER **
 ** ./src/modules/home/OldView.js
 **/